import {useLocale} from "../../hooks/use-locale";

interface DailymotionProps {
    id: string;
    title?: string;
}

export function Dailymotion({id, title}: DailymotionProps) {
    const locale = useLocale()

    return <div style={{
        position: "relative",
        paddingBottom: "56.25%",
        marginBottom: "1rem",
        height: 0,
        overflow: "hidden"
    }}>

        <iframe
            src={`//www.dailymotion.com/embed/video/${id}?queue-enable=false&sharing-enable=false&ui-logo=false&subtitles-default=${locale}`}
            style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0}}
            allowFullScreen
            title={title || "DailyMotion Video"}></iframe>

    </div>
}
